module.exports = __webpack_public_path__ + "img/ZJ5254.7d87740e.png";